import { TablePattern } from './table-patterns';
import { Timestamp } from 'firebase/firestore';
// tslint:disable: variable-name


export class Alert extends TablePattern {
  title: string;
  description: string;
  viewed: boolean;
  user_id: number;
  source_entity: number;
  target_entity: number;
  action_text?: string;
  message?: string;
  action_link?: string;
  viewed_at?: string | Timestamp;
  source_link?: string;
  alert_type: string;
  source_entity_photo_path?: string;

  constructor(o: Partial<Alert>) {
    super(o);
  }
}
